"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavBarList = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../../styles/index.js");
var _index2 = require("../TypeList/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var _excluded = ["as"];
var NavBarListElement = (0, _styledComponents["default"])(_index2.TypeList).attrs({
  condensedAll: true,
  listStyleReset: true
}).withConfig({
  displayName: "NavBarList__NavBarListElement",
  componentId: "sc-19lzbdt-0"
})(["display:flex;margin-block-end:", ";overflow-x:auto;overflow-wrap:break-word;padding:", ";-ms-overflow-style:none;scrollbar-width:none;&::-webkit-scrollbar{display:none;}"], (0, _index.cssSpacing)('tighter', '12px'), (0, _index.cssSpacing)('tighter-5', '2px'));

/**
 * @deprecated
 * This component will be archived soon.
 * Use the TabsList component instead.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-navbar-navbarlist--docs) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/NavBarList) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-12653&t=X3Pv9ZLvoMIaXVBJ-1)
 */
var NavBarList = exports.NavBarList = /*#__PURE__*/_react["default"].forwardRef(function NavBarList(_ref, ref) {
  var as = _ref.as,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(NavBarListElement, Object.assign({}, props, {
    ref: ref,
    forwardedAs: as,
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.NavBarList
  }));
});